<template>
    <div :class="cssClass + ' card--' + card.subsectionType" @click.self="onClickCard">
        <v-card>
            <v-card-text>
                <div class="row">
                    <div class="col-md-12">
                        <p class="text-small" v-if="((card.subsectionType === 'decree') || (card.subsectionType === 'regulation') || (card.subsectionType === 'attachment')) && showActStatuteLinks">
                            <span v-if="card.provisions.length > 0">{{ $t('sammio.provision') }} </span>
                            <span v-for="(provision, index) in card.provisions" :key="`provision-${provision.section}-${provision.subsection}`">
                                <a href="#" @click.prevent="onClickSubsectionLink(provision.statute, provision.chapter, provision.section, provision.subsection)">{{ $t('sammio.by_radiation_act') }} {{provision.section}} §<span v-if="locale === 'fi'">:n</span> {{provision.subsection}} {{ $t('sammio.subsection') }}</a>{{ getListSeparator(card.provisions.length, index, true) }}
                            </span>
                                <span v-if="card.authorizations.length > 0"> {{ card.subsectionType === 'decree' ? getSecondListTitle(card.provisions.length, $t('sammio.issued')) : getSecondListTitle(card.provisions.length, $t('sammio.regulated')) }} </span>
                                <span v-for="(authorization, index) in card.authorizations" :key="`authorization-${authorization.section}-${authorization.subsection}`">
                                <a href="#" @click.prevent="onClickSubsectionLink(authorization.statute, authorization.chapter, authorization.section, authorization.subsection)">{{ $t('sammio.by_radiation_act') }} {{authorization.section}} §<span v-if="locale === 'fi'">:n</span> {{authorization.subsection}} {{ $t('sammio.by_subsection') }}</a>
                                {{ getListSeparator(card.authorizations.length, index, false) }}
                            </span>
                            {{ $t('sammio.under') }}.
                        </p>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-11" @click="onClickCard">
                        <h2 v-if="card.subsectionType === 'attachment'"
                          class="card__title--main statute-title"
                          v-html="getHighlightedHtml(getChapterTitle())">
                        </h2>
                        <h2 v-if="card.subsectionType !== 'attachment'"
                            class="card__title--main statute-title"
                            v-html="getHighlightedHtml(card.statuteTitle)">
                        </h2>
                        <h3
                            class="card__title--main chapter-title" 
                            v-if="card.subsectionType !== 'attachment' && card.chapterTitle !== ''"
                            v-html="getHighlightedHtml(getChapterTitle())">
                        </h3>
                        <h3 v-if="card.subsectionType !== 'attachment'"
                            class="card__title--main subsection-title-combined" 
                            v-html="getHighlightedHtml(getSubSectionTitleCombined())">
                        </h3>
                        <h3 v-if="card.subsectionType === 'attachment'"
                            class="card__title--main subsection-title-combined"
                            v-html="getHighlightedHtml(card.statuteTitle)">
                        </h3>
                        <!--
                        <h3 
                            class="card__title--main subsection-title" 
                            v-if="this.locale == 'en'" 
                            v-html="getHighlightedHtml(getSubSectionTitle())">
                        </h3>
                        <h3 
                            class="card__title--main subsection-name" 
                            v-if="this.locale == 'en'" 
                            v-html="getHighlightedHtml(getSubSectionName())">
                        </h3>
                        -->
                    </div>

                    <div class="ml-auto mr-2">
                        <v-btn
                                v-if="card.subsectionType !== 'attachment'"
                                @click="onClickBookmark()"
                                class="btn--nostyle v-input__icon--append"
                        >
                            <span class="sr-only">{{isBookmarked ? $t('sammio.bookmarks.remove_from_bookmarks') : $t('sammio.bookmarks.add_to_bookmarks')}}</span>
                            <favourite-single v-if="!isBookmarked"></favourite-single>
                            <favourite-single-highlight v-if="isBookmarked"></favourite-single-highlight>
                        </v-btn>
                    </div>
                </div>
                <div v-if="(card.subsectionType === 'act') && ((this.card.decreeLinks.length > 0) || (this.card.regulationLinks.length > 0))">
                    <div class="sammio-accordion__header row">
                        <div class="col-md-11">
                            <v-btn class="btn btn-link p-0" :aria-expanded="relatedDecreesAndRegulationsVisible ? 'true' : 'false'" :aria-controls="'accordion_content_related-'+this.index" :id="'accordion_header_related_text-'+this.index" @click.prevent="relatedDecreesAndRegulationsVisible = !relatedDecreesAndRegulationsVisible">
                                {{ relatedDecreesOrRegulationsTitle}}
                            </v-btn>
                        </div>
                        <div class="col-md-1 p-0 text-right">
                            <v-btn class="btn btn-link p-0 mb-0 mr-2" :aria-expanded="relatedDecreesAndRegulationsVisible ? 'true' : 'false'" :aria-controls="'accordion_content_related-'+this.index" :id="'accordion_header_related_button-'+this.index" @click.prevent="relatedDecreesAndRegulationsVisible = !relatedDecreesAndRegulationsVisible">
                                <span class="text-right" v-if="!relatedDecreesAndRegulationsVisible">
                                    <plus-icon size="1.25x"></plus-icon>
                                </span>
                                <span class="text-right" v-else>
                                    <minus-icon size="1.25x"></minus-icon>
                                </span>
                            </v-btn>
                        </div>
                    </div>
                    <div class="row sammio-accordion__content" :id="'accordion_content-'+this.index" :aria-labelledby="'accordion_header-'+this.index" v-if="relatedDecreesAndRegulationsVisible" :aria-hidden="relatedDecreesAndRegulationsVisible ? 'false' : 'true'">
                        <div class="col-md-12">
                            <div class="mb-3" v-if="card.decreeLinks.length > 0">
                                <h4 class="card__title--subtitle" v-if="hasRegulationLinks">{{ $t('sammio.decrees') }}</h4>
                                <ul class="list-unstyled">
                                    <li v-for="(decreeLink, statuteTitle) in decreeLinkGroups">
                                        <strong>{{statuteTitle}}</strong>
                                        <ul class="list-unstyled">
                                            <li v-for="decree in decreeLink" :key="`decree-${decree.section}-${decree.subsection}`">
                                                <a href="#" @click.prevent="onClickSubsectionLink(decree.statute, decree.chapter, decree.section, decree.subsection)">{{decree.section}} § {{decree.sectionTitle[locale]}}, {{decree.subsection}} {{ $t('sammio.subsection') }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div class="mb-3" v-if="card.regulationLinks.length > 0">
                                <h4 class="card__title--subtitle"  v-if="hasDecreeLinks">{{ $t('sammio.regulations') }}</h4>
                                <ul class="list-unstyled">
                                    <li v-for="(regulationLink, statuteTitle) in regulationLinkGroups">
                                        <strong>{{statuteTitle}}</strong>
                                        <ul class="list-unstyled">
                                            <li v-for="regulation in regulationLink" :key="`regulation-${regulation.section}-${regulation.subsection}`">
                                                <a href="#" @click.prevent="onClickSubsectionLink(regulation.statute, regulation.chapter, regulation.section, regulation.subsection)">{{regulation.section}} § {{regulation.sectionTitle[locale]}}, {{regulation.subsection}} {{ $t('sammio.subsection') }}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>

            <div v-if="(card.attachmentLinks && card.attachmentLinks.length > 0)">
                <div class="sammio-accordion__header row">
                  <div class="col-md-11">
                    <h4 class="card__title--subtitle">{{ attachmentsTitle }}</h4>
                  </div>
                  <div class="col-md-1 p-0 text-right">
                    <v-btn class="btn btn-link p-0 mb-0 mr-2" :aria-expanded="card.openAttachmentLink ? 'true' : 'false'" :aria-controls="'accordion_content_attachment-'+this.index" :id="'accordion_attachment_button-'+this.index" @click.prevent="card.openAttachmentLink = !card.openAttachmentLink">
                      <span class="text-right" v-if="!card.openAttachmentLink">
                          <plus-icon size="1.25x"></plus-icon>
                      </span>
                      <span class="text-right" v-else>
                          <minus-icon size="1.25x"></minus-icon>
                      </span>
                    </v-btn>
                  </div>
                </div>
                <div class="row sammio-accordion__content" :id="'accordion_content-'+this.index" :aria-labelledby="'accordion_attachment-'+this.index" v-if="card.openAttachmentLink" :aria-hidden="card.openAttachmentLink ? 'false' : 'true'">
                  <div class="col-md-12">
                    <div class="mb-3" v-if="card.attachmentLinks.length > 0">
                      <ul class="list-unstyled">
                        <li v-for="(attachment) in card.attachmentLinks" :key="`attachment-${attachment.name}-${attachment.classPK}`">
                          <ul class="list-unstyled">
                            <li>
                              <a href="#" @click.prevent="onClickAttachmentLink(attachment.classPK)">{{attachment.name}}</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                    <h4 class="card__title--subtitle">{{ subsectionHeading }}</h4>
                    <p class="sammio-card-data" v-html="getHighlightedHtml(card.subsection)"></p>
                </div>
                <div>
                    <div class="row">
                        <div class="col-md-11">
                            <h4 :class="'card__title--subtitle ' + (isJustificationVisible ? 'sectionVisible' : 'sectionHidden')">{{ $t('sammio.justification') }}</h4>
                        </div>
                        <div class="col-md-1 p-0 text-right">
                            <v-btn
                                class="btn btn-link btn-icon p-0 mb-0 mr-2"
                                @click="toggleSectionVisible('justification')"
                                :aria-expanded="isJustificationVisible ? 'true' : 'false'" 
                                :aria-controls="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-justification`"
                            >
                              <span class="sr-only">{{$t('sammio.justification')}}</span>
                              <minus-icon  v-if="isJustificationVisible" size="1.25x"></minus-icon>
                              <plus-icon  v-else size="1.25x"></plus-icon>
                            </v-btn>
                        </div>
                    </div>
                    <p :id="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-justification`" v-if="isJustificationVisible" v-html="getHighlightedHtml(card.justification)"></p>
                </div>
                <div>
                    <div class="row">
                        <div class="col-md-11">
                            <h4 :class="'card__title--subtitle ' + (isGuidanceVisible ? 'sectionVisible' : 'sectionHidden')">{{ $t('sammio.guidance') }}</h4>
                        </div>
                        <div class="col-md-1 p-0 text-right">
                            <v-btn
                                    class="btn btn-link btn-icon p-0 mb-0 mr-2"
                                    @click="toggleSectionVisible('guidance')"
                                    :aria-expanded="isGuidanceVisible ? 'true' : 'false'" 
                                    :aria-controls="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-guidance`"
                            >
                                <span class="sr-only">{{$t('sammio.guidance')}}</span>
                                <minus-icon size="1.25x" v-if="isGuidanceVisible"></minus-icon>
                                <plus-icon size="1.25x" v-else></plus-icon>

                            </v-btn>
                        </div>
                    </div>
                    <sammio-card-guidance 
                        :id="`card-${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}-guidance`"
                        :cardIndex="`${card.statuteIndex}-${card.chapterIndex}-${card.sectionIndex}-${card.subsectionIndex}`" 
                        v-show="isGuidanceVisible"
                        :contentHtml="guidanceContent"
                        :hiddenHeadings="card.hiddenGuidanceHeadingIndices"
                        @update-hidden-guidance-indices="updateHiddenGuidanceIndices"
                    >
                    </sammio-card-guidance>

                </div>
            </v-card-text>
        </v-card>
    </div>

</template>

<script>

    import { i18n } from "../translations/i18n"
    import { groupBy } from 'lodash'
    import FavouriteSingle from "./icons/FavouriteSingle"
    import FavouriteSingleHighlight from "./icons/FavouriteSingleHighlight"
    import { PlusIcon, MinusIcon } from 'vue-feather-icons'
    import {isSameCard} from "../store/helpers";
    import { mapGetters } from 'vuex'
    import SammioCardGuidance from "./SammioCardGuidance";
    import SammioModal from "@/components/SammioModal.vue";
    import SammioIconShareHighlight from "@/components/icons/ShareHighlight.vue";
    import SammioIconShare from "@/components/icons/Share.vue";

    export default {
        name: "SammioCard",
        components: {
            SammioIconShare, SammioIconShareHighlight, SammioModal,
            SammioCardGuidance,
            FavouriteSingle,
            FavouriteSingleHighlight,
            PlusIcon,
            MinusIcon
        },
        data() {
            return {
                attachmentsVisible: true,
                relatedDecreesAndRegulationsVisible: false,
                card: {
                    ...this.cardProps
                }
            }
        },
        props: {
            cardProps: {
                statuteTitle: String,
                chapterTitle: String,
                subsectionTitle: String,
                subsectionName: String,
                subsectionTitleCombined: String,
                subsectionType: String,
                subsection: String,
                justification: String,
                guidance: String,
                provisions: Array,
                authorizations: Array,
                decreeLinks: Array,
                regulationLinks: Array,
                statuteIndex: Number,
                chapterIndex: Number,
                sectionIndex: Number,
                subsectionIndex: Number,
                justificationVisible: Boolean,
                guidanceVisible: Boolean,
                hiddenGuidanceHeadingIndices: Array,
                openAttachmentLink: Boolean

            },
            cssClass: String,
            index: Number,
            searchTerms: String
        },
        methods: {
            updateHiddenGuidanceIndices(payload) {
                this.card.hiddenGuidanceHeadingIndices = payload.indices
                this.$store.dispatch('updateBookmarkGuidanceHeadingsVisibility', {
                    index: this.index,
                    value: payload.indices
                })
            },
            toggleSectionVisible(type) {
                const prop = type + 'Visible'
                const value = !this.card[prop]
                this.card[prop] = value
                this.$store.dispatch('updateBookmarkContentVisibility', {
                    index: this.index,
                    type: type,
                    value: value
                })
            },
            onClickSubsectionLink(statuteIndex, chapterIndex, sectionIndex, subsectionIndex) {
                this.$emit('click-subsection-link', {
                    indices: {
                        statuteIndex,
                        chapterIndex,
                        sectionIndex,
                        subsectionIndex,
                    }
                })
            },
            onClickAttachmentLink(classPK) {
              this.$emit('click-attachment-link', {
                classPK: classPK
              })
            },
            onClickBookmark() {
                if (this.isBookmarked) {
                    this.removeBookmark()
                } else {
                    this.addBookmark()
                }
            },
            onClickCard() {
                if (Liferay.ThemeDisplay.isSignedIn()) {
                    if(this.card.subsectionType != 'attachment') {
                      let path = `/${this.card.statuteIndex}/${this.card.chapterIndex}/${this.card.sectionIndex}/${this.card.subsectionIndex}`
                      if (path !== this.$router.currentRoute.path) {
                        if (i18n.locale !== 'fi') {
                          path = path + '?lang=' + i18n.locale
                        }
                        this.$router.push(path)
                      }
                    }
                }
            },
            getListSeparator(listLength, index, appendComma) {
                if ((listLength === 2) && (index === 0)) {
                    return ' ' + this.$t('sammio.and') + ' '
                } else if (listLength > 2) {
                    if (index === (listLength - 1)) {
                        return appendComma ? ',' : ''
                    } else if (index === (listLength - 2)) {
                        return ' ' + this.$t('sammio.and') + ' '
                    } else {
                        return ', '
                    }
                }
                return appendComma ? ', ' : ''
            },
            getSecondListTitle(decreeListLength, title) {
                if (decreeListLength === 0) {
                    return title[0].toUpperCase() + title.slice(1)
                }
                return title
            },
            addBookmark() {
                this.$store.dispatch('addBookmark', {
                    cards: [this.card]
                });
                jQuery('#announcer').text(this.$t('sammio.bookmarks.added_to_bookmarks'));
            },
            removeBookmark() {
                this.$store.dispatch('removeBookmark', {
                    card: this.card
                });
                jQuery('#announcer').text(this.$t('sammio.bookmarks.removed_from_bookmarks'));
            },
            stripHttpPortFromSammioLinks(text) {
                // needed to open linked cards to same view instead of reloading the page
                let portRegex = /:(\d+)/
                let portMatch = Liferay.ThemeDisplay.getPortalURL().match(portRegex)
                if (portMatch === null) {
                    let contentRegexPattern = '(stuk.(fi|local\\w*)):\\d+'
                    let contentRegex = new RegExp(contentRegexPattern, 'g')
                    text = text.replaceAll(contentRegex, '$1')
                }
                return text;
            },
            setLinkPlaceholders(text) {
                const aElementRegex = '(<a .*?</a>)'
                let regex = new RegExp(aElementRegex, 'ig')
                let links = []
                let index = 0
                text = text.replace(regex, function (match) {
                    links.push(match)
                    return `knrtpbflkqztvc_${index++}`
                })
                return {
                    text: text,
                    links: links
                }
            },
            replaceLinkPlaceholders(text, links) {
                for (let i = 0; i < links.length; i++) {
                    text = text.replace('knrtpbflkqztvc_' + i, links[i])
                }
                return text
            },
            getHighlightedHtml(text) {
                if (text) {
                    text = this.stripHttpPortFromSammioLinks(text)
                    if (this.$router.currentRoute.name.startsWith('search') && this.searchTerms && (this.searchTerms !== '')) {
                        let linkPlaceholders = this.setLinkPlaceholders(text)
                        text = linkPlaceholders.text
                        let keywords = []
                        let searchTerms = this.searchTerms

                        // extract sections and chapters before 'normal' keywords
                        let sectionRegex = /\s*(\d+)\s*§\s*/g
                        searchTerms = searchTerms.replace(sectionRegex, function(match, capture) {
                            keywords.push(capture + ' §')
                            return ''
                        })

                        let chapterRegex = /\s*(\d+)\s*(luku|kap\.?)\s*/gi
                        searchTerms = searchTerms.replace(chapterRegex, function(match, capture1, capture2) {
                            keywords.push(capture1 + ' ' + capture2)
                            return ''
                        })

                        const remainingKeywords = searchTerms.split(/\s+/)
                        keywords.push(...remainingKeywords)

                        // ignore empty and too short keywords
                        keywords = keywords.filter(k => (
                            (typeof k !== 'undefined') &&
                            (k.replace(/\s/g, '').length) &&
                            (k.length > 1)))

                        let that = this
                        keywords = keywords.map(k => that.escapeRegex(k))
                        keywords = keywords.map(k => k.replace(/[*?]/g, ''))

                        if (keywords.length) {
                            const keywordsRegex = '(' + keywords.join('|') + ')'
                            let regex = new RegExp(keywordsRegex, 'ig')
                            text = text.replace(regex, function(match) {
                                return "<span class='highlight'>" + match + "</span>"
                            })
                        }
                        text = this.replaceLinkPlaceholders(text, linkPlaceholders.links)
                    }
                }
                return text
            },
            getChapterTitle() {
                let title = this.card.chapterTitle
                if (this.locale == "en") {
                    // e.g. "Chapter 1 General provisions"
                    if(this.card.chapterTitleReversed !== '') {
                       title = this.capitalize(this.card.chapterTitleReversed);
                    }
                }
                return title;
            },
            getSubSectionTitle() {
                let title = this.card.subsectionTitle;
                if (this.locale == "en") {
                    // e.g. Section 1 Purpose of the Act
                    title = this.capitalize(this.card.sectionTitleReversed);
                }
                return title;
            },
            getSubSectionName() {
                let title = this.card.subsectionName;
                if (this.locale == "en") {
                    // e.g. Subsection 1
                    title = this.capitalize(this.card.sectionNameReversed);
                }
                return title;
            },
            getSubSectionTitleCombined() {
                let title = this.card.subsectionTitleCombined;
                if (this.locale == "en") {
                    // e.g. "Section 1 Purpose of the Act, subsection 1"
                    title = this.capitalize(this.card.sectionTitleReversed + ", " + this.card.sectionNameReversed);
                }
                return title;
            },
            capitalize(text) {
                const first = text[0].toUpperCase();
                const rest = text.slice(1);

                return first + rest;
            },
            escapeRegex(string) {
               return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            }
        },
        computed: {
            ...mapGetters([
                'getBookmarks'
            ]),
            showActStatuteLinks() {
                return (this.card.provisions.length > 0) || (this.card.authorizations.length > 0)
            },
            subsectionHeading() {
                return this.$t('sammio.subsectionTitle')
            },
            hasDecreeLinks() {
                return this.card.decreeLinks.length > 0
            },
            hasRegulationLinks() {
                return this.card.regulationLinks.length > 0
            },
            hasAttachmentLinks() {
              return this.card.attachmentLinks && this.card.attachmentLinks.length > 0
            },
            relatedDecreesOrRegulationsTitle() {
                if (this.hasDecreeLinks && this.hasRegulationLinks) {
                    return this.$t('sammio.related_decrees_and_regulations')
                }
                if (this.hasDecreeLinks) {
                    return this.$t('sammio.related_decrees')
                }
                if (this.hasRegulationLinks) {
                    return this.$t('sammio.related_regulations')
                }
            },
            attachmentsTitle() {
              if (this.hasAttachmentLinks) {
                return this.$t('sammio.attachments_title')
              }
            },
            locale() {
                return i18n.locale
            },
            decreeLinkGroups() {
                const iteratee = 'statuteTitle.' + this.locale
                return groupBy(this.card.decreeLinks, iteratee)
            },
            regulationLinkGroups() {
                const iteratee = 'statuteTitle.' + this.locale
                return groupBy(this.card.regulationLinks, iteratee)
            },
            isBookmarked() {
                return this.getBookmarks.filter(card => isSameCard(card, this.card)).length > 0
            },
            isJustificationVisible() {
                return this.card.justificationVisible
            },
            isGuidanceVisible() {
                return this.card.guidanceVisible
            },
            guidanceContent() {
                return this.getHighlightedHtml(this.card.guidance)
            }
        }
    }
</script>

<style>
  .sammio-card-data ol li ol {
    list-style-type: lower-alpha !important;
  }
</style>
